export const sensitiveFieldNames = [
  "password",
  "email",
  "userEmail",
  "bank_account_number",
  "bankAccountSortCode",
  "bankAccountNumber",
  "bankAccountName",
  "userName",
  "accountName",
  "firstName",
  "lastName",
  "forename",
  "surname",
  "careOf",
  "first_name",
  "last_name",
  "full_name",
  "phoneNumber1",
  "phoneNumber2",
  "date_of_birth",
  "customer-first-name",
  "customer-last-name",
  "customer-email",
  "customer-phone",
  "sortCode",
  "agentName",
  "agentEmail",
  "amountInPence",
  "token",
  "customerName",
  "password_confirmation",
  "bankSortCode",
  "bankAccountName",
  "Product",
  "Period",
  "Price",
  "Volume",
  "Counterparty",
  "Trader",
  "Notes",
  "Period",
  "PercentOfBaseload",
  "ConfirmSignedBy",
  "accountNumber",
]

export const REDACTED_PLACEHOLDER = "*REDACTED*"
